<template>
  <div>
    <div class="ui basic modal" ref="loginGuide">
      <div class="ui icon header">
        <i class="blue sign in alternate icon"></i>
        {{$t('Welcome to EZCast')}}
      </div>
      <div class="content">
        <p>{{message}}</p>
      </div>
      <div class="actions">
        <div class="ui red basic cancel inverted button" @click="cancelLogin()">
          {{$t('Later')}}
        </div>
        <div class="ui blue ok button" @click="login()">
          {{$t('Sign In Now')}}
        </div>
      </div>
    </div>
    <div class="ui basic modal" ref="errorDialog">
      <div class="ui icon header">
        <i class="exclamation circle icon"></i>
        {{$t('Cannot Connect to the Device')}}
      </div>
      <div class="content">
        <p>{{$t('We cannot connect to the device now. Please make sure the device is online or try again later.', {keySeparator:'#'})}}</p>
      </div>
      <div class="actions">
        <div class="ui ok inverted button">
          {{$t('Okay')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const gtag = window.gtag;

export default {
  props: ['action', 'message'],
  methods: {
    show() {
      window.$(this.$refs.loginGuide).modal('show');
    },
    login() {
      const urlParams = new URLSearchParams(window.location.search);
      let redirect_url = urlParams.get('redirect_url');
      if (redirect_url) {
        if (this.action) {
          redirect_url = `${redirect_url}&action=${this.action}`;
        }
        const authUrl = process.env.VUE_APP_AUTH_BASE_URL;
        // 換domain之後改用直接redirect {T7580}
        // const anotherRedirect = encodeURIComponent(`${authUrl}/oauth/ezcast?connect=skip&redirect_url=${encodeURIComponent(redirect_url)}`);
        gtag('event', 'login', {
          method : 'EZCast Auth',
          event_callback () {
            location.href = `${authUrl}?redirect_url=${encodeURIComponent(redirect_url)}`;
          },
        });
      }
      return;
    },
    cancelLogin() {
      gtag('event', 'cancel_login', {
        event_category: 'engagement',
      });
    },
  },
}
</script>
